<app-logo></app-logo>
<header class="m-b-4">
    <h1>{{ header }}</h1>
</header>
